module.exports = __webpack_public_path__ + "static/assets/d7476c2ceb378f267ace07e6ea4c93f2.svg";